export const ImageCDNBaseURL: string = "https://res.cloudinary.com/dct9np835/image/upload/";